import React, { PropsWithChildren } from 'react'

export const Section: React.FC<PropsWithChildren> = ({ children }) => (
  <section className="flex flex-col m-0 box-border w-full md:flex-col lg:flex-row">
    {children}
  </section>
)
